import disposableDomains from 'disposable-email-domains'

const DISPOSABLE_SET: Set<string> = new Set(
  disposableDomains.map((d: string) => d.toLowerCase()),
)

const COMMON_TYPO_FIXES: Record<string, string> = {
  'gmial.com': 'gmail.com',
  'gnail.com': 'gmail.com',
  'gmai.com': 'gmail.com',
  'gmaill.com': 'gmail.com',
  'gmail.co': 'gmail.com',
  'gmail.con': 'gmail.com',
  'gmail.fr': 'gmail.com',
  'gnaill.com': 'gmail.com',
  'gmali.com': 'gmail.com',
  'gmal.com': 'gmail.com',
  'yahoo.con': 'yahoo.com',
  'yaho.com': 'yahoo.com',
  'yahooo.com': 'yahoo.com',
  'yahoo.co': 'yahoo.com',
  'yahoo.fr.com': 'yahoo.fr',
  'outlok.com': 'outlook.com',
  'outlook.con': 'outlook.com',
  'outlok.fr': 'outlook.fr',
  'hotmai.com': 'hotmail.com',
  'hotmial.com': 'hotmail.com',
  'hotmaill.com': 'hotmail.com',
  'hotmail.con': 'hotmail.com',
  'hotmail.co': 'hotmail.com',
  'hotmal.com': 'hotmail.com',
  'icloud.con': 'icloud.com',
  'icloud.co': 'icloud.com',
  'orang.fr': 'orange.fr',
  'oragne.fr': 'orange.fr',
  'wanadoo.com': 'wanadoo.fr',
  'laposte.fr.com': 'laposte.net',
  'fre.fr': 'free.fr',
  'fee.fr': 'free.fr',
}

export interface EmailValidationResult {
  ok: boolean
  reason?: 'disposable' | 'typo'
  suggestion?: string
}

export function parseEmailError(
  rawMessage: string,
): { key: string; params?: Record<string, string> } {
  if (rawMessage.startsWith('typoEmail:')) {
    const suggestion = rawMessage.slice('typoEmail:'.length)
    return { key: 'typoEmail', params: { suggestion } }
  }
  return { key: rawMessage }
}

export function validateEmailDomain(email: string): EmailValidationResult {
  const domain = email.split('@')[1]?.trim().toLowerCase()
  if (!domain) {
    return { ok: true }
  }

  if (DISPOSABLE_SET.has(domain)) {
    return { ok: false, reason: 'disposable' }
  }

  const typoFix = COMMON_TYPO_FIXES[domain]
  if (typoFix) {
    const localPart = email.split('@')[0]
    return { ok: false, reason: 'typo', suggestion: `${localPart}@${typoFix}` }
  }

  return { ok: true }
}
